<template>
  <Requirements :process="2" @nextClick="toNext" />
</template>

<script>
  export default {
    name: 'CorporationA',
    pRouter: 'ChooseMerchantType',
    data() {
      return {
      }
    },
    methods: {

    }
  }
</script>


<style lang="scss" scoped>

</style>
